module.exports = __webpack_public_path__ + "static/img/bg10.1_jcjg_icon.png";